import { useRef, useState } from "react";
import { Download } from "lucide-react";
import { StatusBanner } from "@/components/StatusBanner";
import { useProfileTheme } from "@/features/profiles/hooks/useProfileTheme";
import { ThemeLoadState } from "@/features/profiles/components/ProfileThemeEditor";
import { MeetingBackgroundCanvas } from "@/features/assets/background/MeetingBackgroundCanvas";
import { AssetHeader, downloadBlob } from "@/features/assets/assetParts";

export default function BackgroundPage() {
  const t = useProfileTheme();
  const canvas = useRef(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  if (t.load.status !== "ready") return <ThemeLoadState t={t} />;

  const download = () => {
    try {
      canvas.current.toBlob((blob) => (blob ? downloadBlob(blob, "metworth-meeting-background.png") : setError("We couldn't create the image. Please try again.")), "image/png");
    } catch {
      setError("Your photo or logo couldn't be included in the download. Try re-uploading it.");
    }
  };

  return (
    <div data-testid="background-page" className="mw-rise space-y-8">
      <AssetHeader eyebrow="Meeting Background" title="Your meeting background." description="A 1920×1080 virtual background for Zoom, Teams and Meet, matching your card. The centre stays clear for you." />
      <MeetingBackgroundCanvas ref={canvas} identity={t.identity} templateId={t.load.card?.template_id} onRendered={() => setReady(true)} />
      {error && <StatusBanner testId="background-error">{error}</StatusBanner>}
      <button type="button" onClick={download} disabled={!ready} data-testid="background-download-button" className="mw-btn mw-btn-primary">
        <Download className="h-4 w-4" /> Download PNG
      </button>
    </div>
  );
}
